import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {DxDataGridModule} from 'devextreme-angular';

import {ContenidoRoutingModule} from './contenido-routing.module';

import {ContenidoComponent} from './contenido.component';
import {MenuComponent} from './Menu/Menu.component';
import {HomeComponent} from './Home/Home.component';
import {CambiarPasswordComponent} from './CambiarPassword/CambiarPassword.component';

@NgModule({
    declarations:
        [
            ContenidoComponent,
            HomeComponent,
            MenuComponent,
            CambiarPasswordComponent,
        ],
    imports:
        [
            CommonModule,
            ContenidoRoutingModule,
            FormsModule,
            ReactiveFormsModule,
            AngularSvgIconModule.forRoot(),
            TranslateModule,
            DxDataGridModule
        ]
})

export class ContenidoModule {
}
